import React, { memo, useContext } from 'react';
import { Image, Layout } from 'antd';
import BaseMenu from './BaseMenu';
import { MenuItem } from '@/types';
import classNames from 'classnames';
import UnAuthLayoutContext from '@/context/UnAuthLayoutContext';
import { ILayoutContext } from '@/context/LegacyLayoutContext';
import styles from './SideMenu.module.pcss';

const { Sider } = Layout;

interface Props {
  menuItems: Array<MenuItem>;
  isCollapsed: boolean;
}

const SideMenu = memo<Props>((props) => {
  const layoutContext = useContext<ILayoutContext>(UnAuthLayoutContext);

  const renderCustomerLogo = () => {
    if (props.isCollapsed && layoutContext.layoutConfig?.shortLogo) {
      return layoutContext.layoutConfig.shortLogo;
    }
    return layoutContext.layoutConfig.logo;
  };

  return (
    <Sider
      trigger={null}
      breakpoint="lg"
      collapsible
      collapsed={props.isCollapsed}
      collapsedWidth={layoutContext.siderWidth}
      className={styles.sider}
    >
      <div className={classNames(styles.logo, styles[layoutContext.layoutConfig?.title.name])}>
        <Image src={renderCustomerLogo()} alt="logo" preview={false} />
      </div>
      <BaseMenu {...props} mode="inline" />
    </Sider>
  );
});

export default SideMenu;
